import React from 'react'
import { connect } from 'react-redux'
import viewSelector from '../redux/selectors/app/viewSelector'
import { IStore } from '../redux/reducers/index'

const mapStateToProps = (state: IStore) => {
	return viewSelector(state)
}

const withRendererFilter = (Component: any, view: string) => {
	//TODO: find a way to avoid using any here
	const rendererFilter = class Resizer extends React.Component<any> {
		constructor(props: any) {
			super(props)
		}

		shouldComponentUpdate(nextProps: any) {
			return nextProps !== this.props && nextProps.view === view
		}

		render() {
			return <Component {...(this.props as any)} />
		}
	}
	return connect(mapStateToProps)(rendererFilter)
}

export default withRendererFilter
